/**
 * Rejection confirmation loop steps.
 * Each step has a `message`, optional `sub`.
 * The "No" button behavior is controlled by the app state.
 */
export const rejectSteps = [
  {
    message: 'Are you sure?',
    sub: 'Like... actually actually sure?',
    noLabel: 'Still no',
  },
  {
    message: 'Hmm...',
    sub: 'That doesn\'t feel like the right answer ngl 😔',
    noLabel: 'Still no',
  },
  {
    message: 'Be honest.',
    sub: 'Are you just trying to make me suffer a little? 😭',
    noLabel: 'Maybe...',
  },
  {
    message: 'Okay but seriously...',
    sub: 'After all that flirting too?? 😩',
    noLabel: 'Umm...',
  },
  {
    message: 'I mean...',
    sub: 'You do know this button is kinda illegal, right?',
    noLabel: 'Oops',
  },
  {
    message: 'Last chance.',
    sub: 'Choose wisely, miss 😌',
    noLabel: 'Hmm...',
  },
  {
    message: 'One more time...',
    sub: 'You sure you don\'t wanna be mine? 🥺',
    noLabel: '...',
  },
];
